import Tag from 'core/components/Tag';
import React from 'react';
import { Flex, Icon } from 'core/components';

export const CredentialTemplateTypeIcon = (props) => <Icon ml="2px" icon="lock" {...props} />;

export const CredentialTemplateTypeTag = ({ inline = false, withIcon = false, ...rest }) => {
  const inlineProps = inline ? { mt: '1px', ml: 1 } : {};
  return (
    <Tag small {...inlineProps} {...rest}>
      <Flex alignItems="center">
        Template
        {withIcon && (
          <>
            &nbsp;
            <CredentialTemplateTypeIcon iconSize="10" />
          </>
        )}
      </Flex>
    </Tag>
  );
};
